import { Icon, type IconName } from './ui/Icons';

type ShellSection = 'feed' | 'map' | 'offers' | 'profile';

type NavItem = {
  label: string;
  icon: IconName;
  section: ShellSection;
};

const ITEMS: NavItem[] = [
  { label: 'Пульс города', icon: 'friends', section: 'feed' },
  { label: 'Карта', icon: 'map', section: 'map' },
  { label: 'Предложения', icon: 'offer', section: 'offers' },
  { label: 'Профиль', icon: 'profile', section: 'profile' },
];

function navigateViaShell(section: ShellSection): void {
  const target = document.querySelector<HTMLButtonElement>(`.desktop-nav [data-shell-section="${section}"]`);
  target?.click();
}

export function VenueDetailMobileShellNav({ onScan }: { onScan: () => void }) {
  return (
    <nav className="mobile-bottom-nav" aria-label="Основная навигация">
      {ITEMS.map((item, index) => (
        <button
          className={item.section === 'map' ? 'mobile-nav-item is-active' : 'mobile-nav-item'}
          data-venue-shell-section={item.section}
          key={item.label}
          onClick={() => navigateViaShell(item.section)}
          style={index === 2 ? { gridColumn: 4 } : undefined}
          type="button"
        >
          <Icon name={item.icon} />
          <span>{item.label}</span>
          {index === 1 && <span className="mobile-nav-spacer" />}
        </button>
      ))}
      <button className="scan-fab" type="button" aria-label="Сканировать чек" onClick={onScan}>
        <Icon name="scan" />
        <span>Скан</span>
      </button>
    </nav>
  );
}
